import React from 'react';
import { Clock, Repeat, AlertCircle, EyeOff, Frown, Battery } from 'lucide-react';
import { Button } from './ui/Button';
export function CostComparison() {
  const items = [{
    icon: Clock,
    text: 'Meses de gimnasio pagado sin ver cambios reales en el glúteo'
  }, {
    icon: Repeat,
    text: 'Tiempo perdido buscando rutinas en Instagram sin base científica'
  }, {
    icon: AlertCircle,
    text: 'Confianza que se erosiona cada vez que te mirás al espejo'
  }, {
    icon: EyeOff,
    text: 'Energía gastada en entrenamientos sin progresión ni sentido'
  }, {
    icon: Frown,
    text: 'El jean favorito que todavía no cierra como querés'
  }, {
    icon: Battery,
    text: 'Otro mes entrenando igual y esperando resultados diferentes'
  }];
  return <section className="py-16 md:py-24 px-4 bg-surface/40 border-y border-zinc-800/60" data-id="element-84">
      <div className="max-w-4xl mx-auto" data-id="element-85">
        <div className="text-center mb-10 md:mb-14" data-id="element-86">
          <p className="text-red-400 font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3" data-id="element-87">
            ⚖️ El costo real
          </p>
          <h2 className="text-2xl md:text-4xl font-extrabold leading-tight max-w-3xl mx-auto" data-id="element-88">
            ¿Cuánto te cuesta{' '}
            <span className="text-red-400" data-id="element-89">seguir sin resultados?</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 gap-3 md:gap-4 mb-10" data-id="element-90">
          {items.map(({
          icon: Icon,
          text
        }, i) => <div key={i} className="bg-surface border border-zinc-800 rounded-xl p-4 md:p-5 flex items-start gap-3 hover:border-red-500/30 transition-colors" data-id="element-91">
              <div className="w-9 h-9 rounded-lg bg-red-500/10 border border-red-500/30 flex items-center justify-center shrink-0" data-id="element-92">
                <Icon className="w-4 h-4 text-red-400" data-id="element-93" />
              </div>
              <span className="text-zinc-200 text-sm md:text-base leading-snug pt-1" data-id="element-94">
                {text}
              </span>
            </div>)}
        </div>

        <div className="bg-black/40 border border-primary/30 rounded-2xl p-6 md:p-8 text-center" data-id="element-95">
          <p className="text-base md:text-2xl font-bold text-zinc-300 leading-relaxed mb-6" data-id="element-96">
            El próximo mes puede ser igual.
            <br data-id="element-97" />
            O puede ser el mes en que todo cambia.
            <br data-id="element-98" />
            <span className="text-primary text-lg md:text-3xl mt-2 block" data-id="element-99">
              Tu transformación de 30 días empieza hoy.
            </span>
          </p>
          <Button href="#pricing" className="text-base md:text-xl py-3.5 px-8" data-id="element-100">
            👉 EMPEZAR MI TRANSFORMACIÓN AHORA
          </Button>
        </div>
      </div>
    </section>;
}